// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../static/rail-l.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../static/rail-r.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

body {
  display: flex;
  flex-direction: column;
  background: black;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* height: 100%; */
}

#container {
  width: 100%;

  /* height: calc(100% - 62px); */
  height: 100%;
  margin-top: 62px;
  display: flex;
  flex-direction: row;
}

#header2 {
  display: flex;
  flex-direction: row;
  margin-top: 42px;
  background: #333;
  height: 20px;
  position: fixed;
  z-index: 100;
  width: 100%;
}

#tabheader {
  flex: 1;
  height: 100%;
}

#vumeters {
  background: #000;
  flex: 1;
  margin: 2px;
  border-left: 1px solid black;
}

#tabscontainer {
  flex: 1;
}

.sidebar {
  width: 20px;
  background-size: 20px auto;
  background-repeat: repeat-y;
}

.sidebar.left {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.sidebar.right {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.chrome {
  border: 4px solid #333;
  padding: 3px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  height: 100%;
}

.chrome:focus {
  border-color: #777;
  outline: none;
}

.widget {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
}

.widget-with-controls {
  display: flex;
  min-height: 0;
}

.widget-with-controls .widget-controls-horiz {
  flex-direction: row;
}

.widget-with-controls .widget-controls-vert {
  flex-direction: column;
}

.widget-controls {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.widget-with-controls .widget-controls {
  background: #444;
  border-radius: 3px;
}

.widget-titlebar {
  height: 16px;
  background: #444;

  /* margin-bottom: 5px; */
  border-radius: 2px;
  font-size: 12px;
  color: white;
  padding-left: 3px;
}

.grid-stack > .grid-stack-item > .grid-stack-item-content {
  /* left: 2.5px;
  right: 2.5px; */
  background: black;
  display: flex;
  flex-direction: column;
}

.grid-stack .grid-stack-placeholder > .placeholder-content {
  border: 1px dashed lightgray;
  margin: 0;
  left: 2.5px;
  right: 2.5px;
}

.grid-stack > .grid-stack-item > .ui-resizable-se,
.grid-stack > .grid-stack-item > .ui-resizable-sw,
.grid-stack > .grid-stack-item > .ui-resizable-ne,
.grid-stack > .grid-stack-item > .ui-resizable-nw {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center;
  -webkit-transform: rotate(0);
  -moz-transform: rotate(0);
  -ms-transform: rotate(0);
  -o-transform: rotate(0);
  transform: rotate(0);
}

.grid-stack > .grid-stack-item > .ui-resizable-nw {
  cursor: nw-resize;
  width: 20px;
  height: 20px;
  left: -3px !important;
  top: -4px !important;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.grid-stack > .grid-stack-item > .ui-resizable-n {
  cursor: n-resize;
  height: 10px;
  top: 0;
  left: 25px;
  right: 25px;
}

.grid-stack > .grid-stack-item > .ui-resizable-ne {
  cursor: ne-resize;
  width: 20px;
  height: 20px;
  right: -4px !important;
  top: -4px !important;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.grid-stack > .grid-stack-item > .ui-resizable-e {
  cursor: e-resize;
  width: 10px;
  right: 10px;
  top: 15px;
  bottom: 15px;
}

.grid-stack > .grid-stack-item > .ui-resizable-se {
  cursor: se-resize;
  width: 20px;
  height: 20px;
  right: -4px !important;
  bottom: -4px !important;
}

.grid-stack > .grid-stack-item > .ui-resizable-s {
  cursor: s-resize;
  height: 10px;
  left: 25px;
  bottom: 0;
  right: 25px;
}

.grid-stack > .grid-stack-item > .ui-resizable-sw {
  cursor: sw-resize;
  width: 20px;
  height: 20px;
  left: -4px !important;
  bottom: -4px !important;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.grid-stack > .grid-stack-item > .ui-resizable-w {
  cursor: w-resize;
  width: 10px;
  left: 10px;
  top: 15px;
  bottom: 15px;
}

.grid-stack {
  margin-bottom: 5px;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yDAA6C;AAC/C;;AAEA;EACE,yDAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;;EAEhB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;iBACe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,mDAAq3B;EACr3B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,MAAM;EACN,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n  background: black;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  /* height: 100%; */\n}\n\n#container {\n  width: 100%;\n\n  /* height: calc(100% - 62px); */\n  height: 100%;\n  margin-top: 62px;\n  display: flex;\n  flex-direction: row;\n}\n\n#header2 {\n  display: flex;\n  flex-direction: row;\n  margin-top: 42px;\n  background: #333;\n  height: 20px;\n  position: fixed;\n  z-index: 100;\n  width: 100%;\n}\n\n#tabheader {\n  flex: 1;\n  height: 100%;\n}\n\n#vumeters {\n  background: #000;\n  flex: 1;\n  margin: 2px;\n  border-left: 1px solid black;\n}\n\n#tabscontainer {\n  flex: 1;\n}\n\n.sidebar {\n  width: 20px;\n  background-size: 20px auto;\n  background-repeat: repeat-y;\n}\n\n.sidebar.left {\n  background-image: url('../static/rail-l.png');\n}\n\n.sidebar.right {\n  background-image: url('../static/rail-r.png');\n}\n\n.chrome {\n  border: 4px solid #333;\n  padding: 3px;\n  border-radius: 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  height: 100%;\n}\n\n.chrome:focus {\n  border-color: #777;\n  outline: none;\n}\n\n.widget {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  min-height: 0;\n}\n\n.widget-with-controls {\n  display: flex;\n  min-height: 0;\n}\n\n.widget-with-controls .widget-controls-horiz {\n  flex-direction: row;\n}\n\n.widget-with-controls .widget-controls-vert {\n  flex-direction: column;\n}\n\n.widget-controls {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.widget-with-controls .widget-controls {\n  background: #444;\n  border-radius: 3px;\n}\n\n.widget-titlebar {\n  height: 16px;\n  background: #444;\n\n  /* margin-bottom: 5px; */\n  border-radius: 2px;\n  font-size: 12px;\n  color: white;\n  padding-left: 3px;\n}\n\n.grid-stack > .grid-stack-item > .grid-stack-item-content {\n  /* left: 2.5px;\n  right: 2.5px; */\n  background: black;\n  display: flex;\n  flex-direction: column;\n}\n\n.grid-stack .grid-stack-placeholder > .placeholder-content {\n  border: 1px dashed lightgray;\n  margin: 0;\n  left: 2.5px;\n  right: 2.5px;\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-se,\n.grid-stack > .grid-stack-item > .ui-resizable-sw,\n.grid-stack > .grid-stack-item > .ui-resizable-ne,\n.grid-stack > .grid-stack-item > .ui-resizable-nw {\n  background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=');\n  background-repeat: no-repeat;\n  background-position: center;\n  -webkit-transform: rotate(0);\n  -moz-transform: rotate(0);\n  -ms-transform: rotate(0);\n  -o-transform: rotate(0);\n  transform: rotate(0);\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-nw {\n  cursor: nw-resize;\n  width: 20px;\n  height: 20px;\n  left: -3px !important;\n  top: -4px !important;\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-n {\n  cursor: n-resize;\n  height: 10px;\n  top: 0;\n  left: 25px;\n  right: 25px;\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-ne {\n  cursor: ne-resize;\n  width: 20px;\n  height: 20px;\n  right: -4px !important;\n  top: -4px !important;\n  -webkit-transform: rotate(-90deg);\n  -moz-transform: rotate(-90deg);\n  -ms-transform: rotate(-90deg);\n  -o-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-e {\n  cursor: e-resize;\n  width: 10px;\n  right: 10px;\n  top: 15px;\n  bottom: 15px;\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-se {\n  cursor: se-resize;\n  width: 20px;\n  height: 20px;\n  right: -4px !important;\n  bottom: -4px !important;\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-s {\n  cursor: s-resize;\n  height: 10px;\n  left: 25px;\n  bottom: 0;\n  right: 25px;\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-sw {\n  cursor: sw-resize;\n  width: 20px;\n  height: 20px;\n  left: -4px !important;\n  bottom: -4px !important;\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.grid-stack > .grid-stack-item > .ui-resizable-w {\n  cursor: w-resize;\n  width: 10px;\n  left: 10px;\n  top: 15px;\n  bottom: 15px;\n}\n\n.grid-stack {\n  margin-bottom: 5px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
